import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Imoveis from "../pages/imoveis/page";
import ImovelDetail from "../pages/imovel/page";
import QuemSomos from "../pages/quem-somos/page";
import Contato from "../pages/contato/page";
import Avaliacao from "../pages/avaliacao/page";
import ConhecaARegiao from "../pages/conheca-a-regiao/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import PropertyForm from "../pages/admin/property-form/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/imoveis",
    element: <Imoveis />,
  },
  {
    path: "/imovel/:id",
    element: <ImovelDetail />,
  },
  {
    path: "/quem-somos",
    element: <QuemSomos />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/avaliacao",
    element: <Avaliacao />,
  },
  {
    path: "/conheca-a-regiao",
    element: <ConhecaARegiao />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/imoveis/novo",
    element: (
      <ProtectedRoute>
        <PropertyForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/imoveis/:id/editar",
    element: (
      <ProtectedRoute>
        <PropertyForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
